import React from "react";
import Imagen from "../../images/modulo2/barrio.png";
import LayoutActividad from "../../components/LayoutActividad";

import { modulo2 } from "../../routes/Module2";
import { modulo3 } from "../../routes/Module3";

import Sidebar from "./Sidebar";
import GuiaDocente from "../../components/GuiaDocente";
import AudioPlayer from "../../audioPlayer/AudioPlayer";
import Audio from "../../audios/modulo2/Cierre.mp3";

const Modulo1Conclusion = () => {
  const crumbs = [
    {
      title: modulo2.title,
      url: "/" + modulo2.url,
    },
    {
      title: `Cierre`,
      url: "cierre",
    },
  ];
  const pages = {
    titlePrev: `${modulo2.content[0].name} - ${modulo2.content[0].activities[7].name}`,
    linkPrev: `${modulo2.url}/${modulo2.content[0].path}/${modulo2.content[0].activities[7].path}`,
  };
  const metadata = {
    color: modulo2.color,
    title: `${modulo2.title}`,
    name: modulo2.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h1 className="my-5">Así es mi barrio</h1>
      <AudioPlayer track={Audio} />

      <p>Para terminar, pensemos…</p>
      <ul>
        <li>¿En qué lugares de este barrio se juntan las personas?</li>
        <li>¿En qué se parece este barrio al tuyo?</li>
        <li>¿Qué es lo que más y menos te gusta de tu barrio?</li>
        <li>
          ¿Por qué es importante que todos colaboremos para convivir en paz en
          nuestro barrio?
        </li>
      </ul>

      <div className="header-img">
        <img src={Imagen} className="card-img-top full-width" alt="..." />
      </div>

      <GuiaDocente>
        <p>
          Lea el título y las preguntas que se plantean. Dialoguen acerca de las
          respuestas. Finalice destacando la importancia de respetar ciertas
          reglas entre vecinos y vecinas para que podamos convivir
          positivamente.
        </p>
      </GuiaDocente>
      <div className="unit-options my-5 d-flex flex-column">
        <p>Ir al siguiente módulo:</p>
        <a href={"/" + modulo3.url}>
          <button className={`btn btn-${modulo2.color} me-2`}>
            {modulo3.title + " >"}
          </button>
        </a>
      </div>
    </LayoutActividad>
  );
};

export default Modulo1Conclusion;
